export default {
  server: {
    server_name: "เซิร์ฟเวอร์",
    player_name: "ตัวละคร",
    nobind: "ยังไม่ผูกบัญชี",
  },
  pop: {
    pleaseIn: "กรุณากรอก",
    pleaseSelect: "กรุณาเลือก",
    phone: "กรุณากรอก เบอร์โทรศัพท์",
    gnjoy: "กรุณากรอก บัญชี GNJOY",
    onlineNo: "กรุณากรอก บัญชีเกม RO Online",
    onlineServe: "กรุณาเลือก เซิร์ฟเวอร์ RO Online",
    twilightServe: "กรุณาเลือก เซิร์ฟเวอร์ RO Twilight",
    twilightRole: "กรุณาเลือก ตัวละคร RO Twilight",
    tips1:
      "*เมื่อทำการผูกบัญชี RO Online และทำภารกิจตามที่กำหนดบนหน้าเว็บสำเร็จ จะได้รับรางวัลดังที่ระบุไว้",
    tips2:
      "*หากไม่ได้ทำการผูกบัญชี RO Online จะถือว่า สละสิทธิ์รับรางวัล RO Online โดยอัตโนมัติ แต่ จะไม่ส่งผลต่อการรับรางวัลของ RO Twilight",
    //
    pleaseLogin: "โปรดล็อกอินก่อน",
    changeSuccess: "เปลี่ยนผูกสำเร็จ",
    giftSuccess: "ส่งโค้ดสำเร็จ",
    phoneBlock: "หมายเลขโทรศัพท์ต้องไม่ว่าง",
    correctPhone: "โปรดกรอกหมายเลขโทรศัพท์ให้ถูกต้อง",
    selectServe: "กรุณาเลือกเซิร์ฟเวอร์",
  },
};
